import React from 'react';
import { object, string, arrayOf, oneOf, number, func } from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ListingItem from '../items/ListingItem';
import Resources from '../resources/';
import ItemPagination from './ItemPagination';
import NoItems from './NoItems';

export default function ListingItemsSection({
    listingItems, resources, itemWrapperModifier, itemDirection, itemType,
    totalPages, currentPage, changePage, resetFilters
}) {
    let resultsWrapperClass = 'listing-items-wrapper';
    if (resources.length >= 1) {
        resultsWrapperClass += ' has-resources';
    }

    return (
        <div className="listing-items-section">
            <div className="listing-items-container">
                <div className={resultsWrapperClass}>
                    <div className="listing-items">
                        <NoItems
                            items={listingItems}
                            resetFilters={resetFilters}
                        />
                        <ReactCSSTransitionGroup
                            component="div"
                            className={`listing-item-container ${itemWrapperModifier}`}
                            transitionName="fade-in-out"
                            transitionAppear={true}
                            transitionAppearTimeout={200}
                            transitionEnterTimeout={200}
                            transitionLeaveTimeout={200}
                        >
                            {listingItems.map((item, index) => (
                                <ListingItem
                                    /* eslint-disable react/no-array-index-key */
                                    // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                                    //         keep using index for now until we find a better solution
                                    key={index}
                                    item={item}
                                    itemDirection={itemDirection}
                                    itemType={itemType}
                                    /* eslint-enable react/no-array-index-key */
                                />
                            ))}
                        </ReactCSSTransitionGroup>
                    </div>
                    <Resources resources={resources} />
                </div>
                <ItemPagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    changePage={changePage}
                />
            </div>
        </div>
    );
}

ListingItemsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingItems: arrayOf(object).isRequired,
    itemWrapperModifier: string.isRequired,
    itemDirection: oneOf(['horizontal', 'vertical']).isRequired,
    itemType: string.isRequired,
    resources: arrayOf(object).isRequired,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    changePage: func.isRequired,
    resetFilters: func.isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/items/index.jsx